/* eslint-disable @typescript-eslint/no-explicit-any */
import { IAuthState } from "@/interfaces/state";
import router from "@/router/index";

export default {
  login: (context: any, payload: IAuthState): void => {
    context.commit("setToken", payload.token);
    context.commit("setExpiresIn", payload.expiresIn);
    context.commit("setType", payload.type);

    const page = payload.type === "USER_RECLASSIFY" ? "/reclassify" : "/";

    router.replace(page);
  },
  logout: (context: any): void => {
    context.commit("setToken", null);
    context.commit("setExpiresIn", null);
    context.commit("setType", null);

    localStorage.removeItem("token");
    localStorage.removeItem("expiresIn");
    localStorage.removeItem("type");

    router.replace("/login");
  },
};
